export const learningExcercisesConstants = {
  DO_EXCERCISE: 'DO_EXCERCISE',
  CLEAR: 'CLEAR_EXCERCISE',
}
